import { HiOutlineFilter, HiOutlineX } from "react-icons/hi";
import { useState } from "react";
import SearchInput from "../searchInput";
import MultiSelectFilter from "../../lib/multiselectFilter";
import RangeFilter from "../../lib/rangeFilter";

const FilterBar = ({
    searchValue,
    onSearchChange,
    onResetPage,
    searchPlaceholder,
    filters = [],
    rangeFilters = [],
    onClearFilters,
    loading = false,
    layout = "inline"
}) => {
    const [mobileOpen, setMobileOpen] = useState(false);

    const appliedFilters = filters.flatMap(filter =>
        filter.selectedValues.map(selectedValue => {
            const optionObj = filter.options?.find(opt => opt.value === selectedValue);

            const labelToShow = optionObj ? optionObj.label : String(selectedValue);

            return {
                key: filter.key,
                value: selectedValue,
                label: labelToShow,
                onRemove: () =>
                    filter.onChange(
                        filter.selectedValues.filter(v => v !== selectedValue)
                    ),
            };
        })
    );

    return (
        <div className="w-full font-montserrat">

            <div className={`flex flex-col gap-3 ${layout === 'inline' ? 'xl:flex-row xl:items-center' : 'xl:flex-col xl:items-stretch'
                }`}>

                <div className={`flex-1 ${layout === 'inline' ? 'min-w-[200px]' : 'w-full'}`}>
                    <SearchInput
                        value={searchValue}
                        onChange={onSearchChange}
                        onResetPage={onResetPage}
                        placeholder={searchPlaceholder}
                    />
                </div>

                <div className={`hidden xl:flex flex-wrap gap-3 ${layout === 'inline' ? 'items-center' : 'mt-1'
                    }`}>
                    {filters.map(filter => (
                        <MultiSelectFilter key={filter.key} {...filter} loading={loading} />
                    ))}

                    {rangeFilters.map(rangeConfig => (
                        <RangeFilter key={rangeConfig.key} {...rangeConfig} />
                    ))}
                </div>

                <div className="xl:hidden flex justify-end">
                    <button
                        className="flex items-center gap-2 px-4 h-10 rounded-xl bg-white border border-slate-300 text-slate-700 hover:bg-slate-50 transition shadow-sm w-full justify-center"
                        onClick={() => setMobileOpen(!mobileOpen)}
                    >
                        <HiOutlineFilter />
                        <span>Filtros</span>
                    </button>
                </div>
            </div>

            {mobileOpen && (
                <div className="xl:hidden mt-3 flex flex-col gap-3 p-4 bg-slate-50 rounded-xl border border-slate-200 animate-fadeIn">
                    {filters.map(filter => (
                        <MultiSelectFilter key={filter.key} {...filter} loading={loading} />
                    ))}
                    {rangeFilters.map(rangeConfig => (
                        <RangeFilter key={rangeConfig.key} {...rangeConfig} />
                    ))}
                </div>
            )}

            {appliedFilters.length > 0 && (
                <div className="mt-2 flex flex-wrap items-center gap-2">
                    {appliedFilters.map((tag, idx) => (
                        <span
                            key={`${tag.key}-${tag.value}-${idx}`}
                            className="flex items-center gap-1 bg-slate-100 text-slate-700 text-xs px-3 py-1.5 rounded-full border border-slate-200"
                        >
                            <span className="font-semibold text-slate-500 mr-1 uppercase text-[10px]">
                                {filters.find(f => f.key === tag.key)?.label}:
                            </span>
                            {tag.label}
                            <button
                                onClick={tag.onRemove}
                                className="ml-1 hover:text-red-500 transition-colors"
                            >
                                <HiOutlineX size={12} />
                            </button>
                        </span>
                    ))}

                    <button
                        onClick={onClearFilters}
                        className="ml-2 text-xs text-slate-500 hover:text-slate-700 underline"
                    >
                        Limpar filtros
                    </button>
                </div>
            )}
        </div>
    );
};

export default FilterBar;